import { Component, Input, OnInit } from '@angular/core';
import { NotificationsService } from 'src/app/features/notifications';

@Component({
    selector: 'app-reminder-notifications',
    templateUrl: './reminder-notifications.component.html',
    styleUrls: ['./reminder-notifications.component.scss'],
    standalone: false
})
export class ReminderNotificationsComponent implements OnInit {
  @Input() notifications: any[] = [];
  loadingNotifications = false;

  constructor(private notificationService: NotificationsService) { }

  ngOnInit(): void {}

  markAsRead(notification: any) {
    if (notification.read) return;
    this.loadingNotifications = true;
    this.notificationService.markReminderNotificationAsRead(notification.id, { targetType: notification.targetType }).subscribe(() => {
      notification.read = true;
      this.loadingNotifications = false;
    }, () => { this.loadingNotifications = false; });
  }
}
